// extracted by mini-css-extract-plugin
export default {"christine":"#e66609","spinner":"styles_spinner__4ffPX","spin":"styles_spin__h5wX6"};